import { render, staticRenderFns } from "./FolderBreadcrumb.vue?vue&type=template&id=f92c9a88"
import script from "./FolderBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FolderBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports